import React from "react";

const AgentResponsiveComp = () => {
  return <>
  
  </>;
};

export default AgentResponsiveComp;
